import { Button, Heading, Text } from '@chakra-ui/react'
import { useState, useRef } from 'react'
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile'

const API_ENDPOINT = '/get-upload-url'

export default function Home() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const [uploadStatus, setUploadStatus] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [turnstileToken, setTurnstileToken] = useState<string>('')
  const turnstileRef = useRef<TurnstileInstance>(null)

  const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY

  if (!TURNSTILE_SITE_KEY) {
    return (
      <div style={{ padding: '2rem', color: 'red', fontWeight: 'bold' }}>
        <Heading>Configuration Error</Heading>
        <Text mt={4}>
          REACT_APP_TURNSTILE_SITE_KEY is not set in .env file.
        </Text>
      </div>
    )
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setSelectedFile(event.target.files[0])
      setUploadStatus('')
    }
  }

  // ... handleUpload 함수 (동일) ...
  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus('⚠️ First select a file.')
      return
    }
    if (!turnstileToken) {
      setUploadStatus('⚠️ Bot verification failed. Please refresh.')
      return
    }

    setIsLoading(true)
    setUploadStatus('⏳ upload URL request sent...')

    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          filename: selectedFile.name,
          fileSize: selectedFile.size,
          turnstileToken: turnstileToken,
        }),
      })

      if (!response.ok) {
        const errorText = await response.text()
        throw new Error(errorText || 'URL Fail')
      }

      const { uploadUrl } = await response.json()
      setUploadStatus('⏳ File uploading...')

      const uploadResponse = await fetch(uploadUrl, {
        method: 'PUT',
        body: selectedFile,
        headers: {
          'Content-Type': selectedFile.type,
        },
      })

      if (!uploadResponse.ok) {
        throw new Error('Upload Fail')
      }

      setUploadStatus('✅ Upload Success!')
      setSelectedFile(null)
      turnstileRef.current?.reset()
      setTurnstileToken('')
    } catch (error) {
      console.error(error)
      if (error instanceof Error) {
        setUploadStatus(`❌ Fail: ${error.message}`)
      } else {
        setUploadStatus('❌ Error')
      }
      turnstileRef.current?.reset()
      setTurnstileToken('')
    } finally {
      setIsLoading(false)
    }
  }

  // 3. UI 렌더링
  return (
    <div
      style={{
        maxWidth: '500px',
        margin: '2rem auto',
        fontFamily: 'sans-serif',
      }}>
      <Heading>Video ya dharura</Heading>

      <Text my={8}>
        Tafadhali pakia video, picha, au sauti, nami nitashiriki kwa vyombo vya
        habari vya kimataifa{' '}
      </Text>

      <input type="file" onChange={handleFileChange} disabled={isLoading} />

      <Turnstile
        ref={turnstileRef}
        siteKey={TURNSTILE_SITE_KEY} // 👈 이제 에러가 발생하지 않습니다.
        onSuccess={setTurnstileToken}
      />

      <Button
        onClick={handleUpload}
        disabled={!selectedFile || isLoading || !turnstileToken}>
        {isLoading ? 'Uploading...' : 'Upload'}
      </Button>

      {uploadStatus && (
        <p style={{ fontWeight: 'bold', marginTop: '1rem' }}>{uploadStatus}</p>
      )}
    </div>
  )
}
